<template>
  <div class="relative bg-white shadow-md overflow-hidden rounded-lg">
    <!-- Tombol Favorite -->
    <Skeleton width="2rem" height="2rem">
      <div class="absolute top-2 right-2 z-10">
        <slot name="favoriteIcon"></slot>
      </div>
    </Skeleton>

    <div class="flex flex-col">
      <Skeleton v-if="loading" width="100%" height="200px" />
      <LazyImage v-else :src="image" :alt="title" :defaultImage="defaultImage" roundedClass="rounded-t-lg"
        class="w-full h-48 object-cover" />

      <!-- Wrapper Konten Properti dengan Border Radius di Bagian Bawah -->
      <div class="p-4 bg-white rounded-t-lg border-red-200">
        <Skeleton width="80%">
          <p class="text-gray-600"> {{ title }}
          </p>
        </Skeleton>

        <!-- Nama Properti -->
        <h2 class="text-md text-gray-800 font-semibold truncate-title">
          <Skeleton width="80%">
            {{ name }}
          </Skeleton>
        </h2>

        <!-- Lokasi Properti -->
        <p class="text-gray-600 text-sm">
          <Skeleton width="100%">
            {{ locationProvince }}, {{ locationCity }}
          </Skeleton>
        </p>

        <!-- Jumlah Tamu dan Luas Kamar -->
        <div v-if="isAllowDetailRoom" class="flex items-center space-x-4 text-gray-500 text-sm mt-2">
          <Skeleton width="50%">
            <span v-if="!loading">
              <AppIcon icon="mdi:person" class="w-5 h-5 mr-1 inline-block" />
              {{ pax }} Guests
            </span>
          </Skeleton>
          <Skeleton width="50%">
            <span v-if="!loading">
              <AppIcon icon="mdi:vector-square" class="w-5 h-5 mr-1 inline-block" />
              {{ sizeRoom }} sqm
            </span>
          </Skeleton>
        </div>

        <div v-if="showDateAvailable" class="text-gray-500 text-sm mt-2 flex flex-row gap-2 items-center">
          <AppIcon icon="uil:calender" class="w-4 h-4" /> Available from: {{ $formatters.formatDate(showDateAvailable) }}
        </div>

        <!-- Skeleton Loader untuk Detail Tamu dan Kamar saat loading -->
        <div v-if="loading" class="flex items-center space-x-4 text-gray-500 text-sm mt-2">
          <Skeleton width="50%" />
          <Skeleton width="50%" />
        </div>
        <!-- Rating dan Reviews -->
        <div class="grid grid-cols-1 items-center gap-x-2 text-yellow-700 text-sm mt-2">
          <Skeleton  width="60%">
            <span v-if="!loading">
              ⭐ {{ rating }} ({{ reviews }} reviews)
            </span>
          </Skeleton>
        </div>

        <!-- Harga Properti -->
        <div class="flex justify-between items-center border-t border-gray-200 pt-2 mt-2">
          <Skeleton width="50%">
          </Skeleton>

          <span v-if="!loading" class="text-gray-900 font-bold text-md flex flex-row justify-between w-full">
            <div class="text-blue-300 font-thin">
              START FROM
            </div>
            <div>{{ $formatters.formatDecimal(price) }} / {{ $t("reservationSummary.night") }}</div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from '@brayamvalero/vue3-skeleton';

export default {
  components: { Skeleton },
  props: {
    image: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    locationCity: {
      type: String,
      default: '',
    },
    locationProvince: {
      type: String,
      default: '',
    },
    price: {
      type: [Number, String],
      default: '',
    },
    rating: {
      type: [Number, String],
      default: 0,
    },
    reviews: {
      type: [Number, String],
      default: '',
    },
    pax: {
      type: [Number, String],
      default: 0,
    },
    sizeRoom: {
      type: [Number, String],
      default: 0,
    },
    isInitiallyFavorited: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isAllowDetailRoom: {
      type: Boolean,
      default: true,
    },
    defaultImage: {
      type: String,
      // default: () => require('@/assets/images/400x300.png') // Referensi ke gambar default di folder assets
      default: () => '/assets/images/ch-placeholder-new.png' // Referensi ke gambar default di folder assets
    },
    showDateAvailable: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFavorited: this.isInitiallyFavorited,
      isImageLoaded: false, // Status gambar utama
    };
  },
  computed: {
    favoriteIcon() {
      return this.isFavorited ? 'mdi:favorite' : 'mdi:favorite-border';
    }
  },
  methods: {
    toggleFavorite() {
      this.isFavorited = !this.isFavorited;
    },
  },
  watch: {
  },
  created() {
    // console.log("Initial image prop:", this.image);
  },
  mounted() {
    // console.log("Image prop after mounting:", this.image);
  },
};
</script>

<style scoped>
.truncate-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Border-radius hanya di bagian atas gambar */
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

/* Border-radius hanya di bagian bawah konten properti */
.rounded-b-lg {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.image-placeholder {
  background-color: #f0f0f0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}
</style>